<template>
  <div class="my-layout-box p-stock-message">
    <list-view
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :isSearchShow="isSearchShow"
      :listMap="listMap"
      :tabList="tabList"
      @changeTab="changeTab"
    >
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { stockOrderData, stockProductData } from "./config";
import { getOrderStockMessage, getProductStockMessage } from "~/api/stockMessage";

export default {
  name: "stockMessage",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: true,
      isButtonShow: false,
      isSearchShow: true,
      listMap: stockProductData,
      tabType: 0,
      tabList: [{ title: "商品库存" }, { title: "订单库存" }]
    };
  },
  methods: {
    async getList(pagination, searchData) {
      const { tabType } = this;
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };

      let list = null;
      if (tabType == 0) {
        this.listMap = stockProductData;
        sendData.AgentOrderNo = searchData.value || "";
        list = await getProductStockMessage(sendData);
      } else if (tabType == 1) {
        sendData.AgentOrderNo = searchData.value || "";
        this.listMap = stockOrderData;
        list = await getOrderStockMessage(sendData);
      }

      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    },
    changeTab(type) {
      this.tabType = type;
    }
  }
};
</script>

<style lang="less" scope></style>
